/**
 * Menu / Navigation JavaScript
 * Handles hamburger menu toggle and mobile navigation
 */

$(document).ready(function () {
  // Elements
  const $hamburger = $(".navbar__hamburger");
  const $mobileMenu = $(".navbar__mobile-menu");
  const $body = $("body");
  const $header = $(".header");

  // Toggle sticky class on scroll
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 0) {
      $header.addClass("is-scrolled");
    } else {
      $header.removeClass("is-scrolled");
    }
  });

  // Toggle mobile menu on hamburger click
  $hamburger.on("click", function () {
    const $this = $(this);

    // Toggle hamburger animation (3 lines -> X)
    $this.toggleClass("is-active");

    // Toggle mobile menu visibility
    $mobileMenu.toggleClass("is-open");

    // Optional: prevent body scroll when menu is open
    $body.toggleClass("menu-open");
  });

  // Close menu when clicking on a mobile menu link
  $(".navbar__mobile-link").on("click", function () {
    $hamburger.removeClass("is-active");
    $mobileMenu.removeClass("is-open");
    $body.removeClass("menu-open");
  });

  // Close menu when clicking outside
  $(document).on("click", function (e) {
    const $target = $(e.target);

    // If click is outside navbar and menu is open
    if (
      !$target.closest(".navbar").length &&
      $mobileMenu.hasClass("is-open")
    ) {
      $hamburger.removeClass("is-active");
      $mobileMenu.removeClass("is-open");
      $body.removeClass("menu-open");
    }
  });

  // Close menu on window resize (if resizing to desktop)
  $(window).on("resize", function () {
    if ($(window).width() >= 1200) {
      $hamburger.removeClass("is-active");
      $mobileMenu.removeClass("is-open");
      $body.removeClass("menu-open");
    }
  });

  // Close menu on Escape key press
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $mobileMenu.hasClass("is-open")) {
      $hamburger.removeClass("is-active");
      $mobileMenu.removeClass("is-open");
      $body.removeClass("menu-open");
    }
  });

  // ==============================================
  // AD EXTRA STICKY BAR
  // ==============================================
  // Shows/hides the extra bar when scrolling past main-title on ad detail page
  const $adExtraBar = $(".pad-extra-bar");
  const $mainTitle = $(".pad-detail-page .main-title");

  // Click on extra bar thumbnail opens main gallery (PhotoSwipe)
  $("#pad-extra-bar-thumb").on("click", function () {
    if (typeof PadGallery !== "undefined" && PadGallery && PadGallery.lightbox) {
      PadGallery.lightbox.loadAndOpen(0, { gallery: document.getElementById('pad-gallery-main') });
    }
  });

  if ($adExtraBar.length && $mainTitle.length) {
    const barMode = $adExtraBar.data("mode") || "below";

    $(window).on("scroll", function () {
      const mainTitleBottom = $mainTitle.offset().top + $mainTitle.outerHeight();
      const scrollTop = $(window).scrollTop();

      if (scrollTop > mainTitleBottom) {
        // Show extra bar
        $adExtraBar.addClass("is-visible");

        // If replace mode, add body class to hide header
        if (barMode === "replace") {
          $body.addClass("pad-extra-bar-replace-active");
        }
      } else {
        // Hide extra bar
        $adExtraBar.removeClass("is-visible");

        // Remove body class
        if (barMode === "replace") {
          $body.removeClass("pad-extra-bar-replace-active");
        }
      }
    });
  }
});
